import _, { get, isEmpty }      from '_';
import { connect }              from 'reflux';
import React, { PropTypes }     from 'react';
import PlaylistItem             from 'components/player/playlist_item';
import HasNodeHeight            from 'mixins/has_node_height';
import URLTracking              from 'mixins/url_tracking';
import { getParams, isMobile }  from 'utils/util';
import ChapterStore             from 'stores/chapter_store';
import ChapterActions           from 'actions/chapter_actions';
import $                        from 'jquery';

export default React.createClass({
  displayName: 'BrandPlay.Chapters',
  propTypes: {
            viewed: PropTypes.object,
             index: PropTypes.number,
             title: PropTypes.string,
          chapters: PropTypes.array,
         headerURL: PropTypes.string,
          children: PropTypes.string,
          duration: PropTypes.number,
    hasMobileStyle: PropTypes.bool,
      useMobileMenu: PropTypes.bool
  },
  mixins: [HasNodeHeight, URLTracking, connect(ChapterStore)],
  getDefaultProps() {
    let index = 0;
    if(typeof getParams().startVideo !== 'undefined') {
      index = getParams().startVideo - 1;
    }
    return {
      chapters: [],
        viewed: {},
         index: index,
      isiLinks: []
    };
  },
  getInitialState() {
    let index = 0;
    if(typeof getParams().startVideo !== 'undefined') {
      index = getParams().startVideo - 1;
    }
    return {
      index: index,
      viewed: this.props.viewed,
      enabled: true
    };
  },
  createHtml(html) {
    const contain = isMobile() ? html : '';
    return {__html: contain};
  },
  shouldComponentUpdate(nextProps, nextState) {
    const thisLock = get(this, 'state.videoLocks.lock', null),
          nextLock = get(nextState, 'videoLocks.lock', null),
          thisLocks = get(this, 'state.videoLocks.lockChildren', []),
          nextLocks = get(nextState, 'videoLocks.lockChildren', []);
    if(thisLock !== nextLock) {
      const lockChildren = get(nextState, 'videoLocks.lock.lockChildren', []);
      if(!isEmpty(lockChildren)) {
        ChapterActions.removeLocks(lockChildren);
      }
      return true;
    }
    if(thisLocks !== nextLocks) {
      return true;
    }
    if(this.state.enabled === false) {
      return false;
    }
    if(nextProps.index !== this.props.index) {
      return true;
    } else if (nextProps.chapters !== this.props.chapters) {
      return true;
    } else {
      return false;
    }
  },
  hasViewed(index) {
    return this.props.viewed[index];
  },
  enableClick() {
    this.setState({
      enabled: true
    });
  },
  disableClick() {
    this.setState({
      enabled: false
    });
  },
  menuClose() {
    $(window).trigger('mobmenu:close');
  },
  renderChapter(chapter, i) {
    const isSelected = parseInt(this.props.index, 10) === parseInt(i, 10),
           hasViewed = this.hasViewed(i),
            isLocked = _.includes(get(this, 'state.videoLocks.lockChildren', []), i+1, 0);

    if(this.props.useMobileMenu) {
        return (<PlaylistItem
            key={`${i}-pl`}
            hasViewed={hasViewed}
            isSelected={isSelected}
            index={i}
            isLocked={isLocked}
            video={chapter}
            enabled={this.state.enabled}
            isMobileItem={true}
        />);
    } else {
        if(this.props.hasMobileStyle) {
            return (<PlaylistItem
                key={`${i}-pl`}
                hasViewed={hasViewed}
                isSelected={isSelected}
                index={i}
                isLocked={isLocked}
                video={chapter}
                enabled={this.state.enabled}
            />);
        } else {
            return (<div key={`${i}-pldiv`} data-chapter={`${i+1}`}><PlaylistItem
                hasViewed={hasViewed}
                isSelected={isSelected}
                isLocked={isLocked}
                index={i}
                video={chapter}
                enabled={this.state.enabled}
            /></div>);
        }
    }
  },
  render() {
    let chapters = _.map(this.props.chapters, this.renderChapter, this);
    let containerClass = this.props.useMobileMenu ? 'playlistContainer mobile-menu' : 'playlistContainer';
    const headerImg = <img src={bpInstance.header}/>;
    const endMatterImg = <img src={bpInstance.endMatter}/>;
    if (chapters.length === 1) {
      chapters = [ ];
    }
    return (
        <div className={containerClass}>
          <div className="playlist">
            <div className="header">{headerImg}</div>
            <div className="episode-title">EPISODES ({this.props.chapters.length})</div>
            <div>
            { chapters }
            </div>
            <div className="endMatter">{endMatterImg}</div>
          </div>
          <a className="menu-close" onClick={this.menuClose}>Cancel</a>
        </div>
    );
  }
});



// WEBPACK FOOTER //
// ./modules/components/brand_play/chapters.jsx